import axios from 'axios';
import useAuthStore from '../../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_ADMIN || 'http://localhost:4000/api/admin',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const createEbook = async (formData) => {
  const form = new FormData();
  
  // Append text fields
  form.append('title', formData.title);
  form.append('author', formData.author);
  form.append('description', formData.description);
  form.append('content', formData.content);
  form.append('hasChapters', formData.hasChapters);
  form.append('genreId', formData.genreId);
  form.append('genreName', formData.genreName);
  form.append('language', formData.language);
  form.append('slug', formData.slug);
  if (formData.author_id) {
    form.append('author_id', formData.author_id);
  }

  // Append series data if present
  if (formData.hasSeries) {
    form.append('seriesId', formData.seriesId);
    form.append('chapterNumber', formData.chapterNumber);
  }

  // Append images if they exist
  if (formData.mobileImage) {
    form.append('mobileImage', formData.mobileImage);
  }
  if (formData.desktopImage) {
    form.append('desktopImage', formData.desktopImage);
  }

  const response = await api.post('/ebook', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateEbook = async ({ id, formData }) => {
  const form = new FormData();
  
  // Append text fields
  form.append('title', formData.title);
  form.append('author', formData.author);
  form.append('description', formData.description);
  form.append('content', formData.content);
  form.append('hasChapters', formData.hasChapters);
  form.append('genreId', formData.genreId);
  
  // Ensure genreName is always included
  form.append('genreName', formData.genreName || '');
  
  form.append('language', formData.language);
  form.append('slug', formData.slug);
  
  // Add flags for image removal
  form.append('removeMobileImage', formData.removeMobileImage);
  form.append('removeDesktopImage', formData.removeDesktopImage);
  
  // Append images if they exist
  if (formData.mobileImage) {
    form.append('mobileImage', formData.mobileImage);
  }
  if (formData.desktopImage) {
    form.append('desktopImage', formData.desktopImage);
  }
  
  // For debugging - log what's being sent
  console.log('Sending form data to server:');
  for (let [key, value] of form.entries()) {
    console.log(`${key}: ${value}`);
  }
  
  const response = await api.put(`/ebook/${id}`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getEbooks = async () => {
  const response = await api.get('/ebook');
  return response.data;
};

export const getEbookById = async (id) => {
  const response = await api.get(`/ebook/${id}`);
  return response.data;
};

export const deleteEbook = async (id) => {
  const response = await api.delete(`/ebook/${id}`);
  return response.data;
};